$(document).foundation();

var headerHeight = 64; // assume item is so below that nav has condensed due to scrolling

filterHandler = {
  $filterTrigger: $('body').find('.filter-trigger'),
  $filterContainer: $('body').find('.filter-container'),
  $seriesContainer: $('body').find('.series-container'),
  $dataContainer: $('body').find('.data-container'),
  //$itemData = $('.item-data'),
  // $pagingContainer = $('body').find('.paging-container'),
  // $paging = $('body').find('.paging-container').children(),
  filteredValue: [],
  
  searchData: function() {
    var self = this;
    var filterType = '';
    var filterLoc = '';
    var filterSer = '';
    
    var filteredType   = [];
    var filteredSeries = []; 
    var filteredLocation = []; 
    self.filteredValue = [];
    //window.history.pushState("", "", "");
    
    this.$filterContainer.find('.filter-trigger').each(function(){
      if (this.checked) {
        if (!self.filteredValue.includes(this.value)) {
          self.filteredValue.push(this.value);
          var type = $(this).data('filter-type');
          if (type == 'type')  {
            filterType += ((filterType != '') ? ',' : '')+this.value;
            filteredType.push(this.value);
          } else if (type == 'location') {
            filterLoc += ((filterLoc != '') ? ',' : '')+this.value;
            filteredLocation.push(this.value);
          }
        }
      }
    })

    this.$seriesContainer.find('.filter-trigger').each(function(){
      if (this.checked) {
        if (!self.filteredValue.includes(this.value)) {
          self.filteredValue.push(this.value);
          filterSer += ((filterSer != '') ? ',' : '')+this.value;
          filteredSeries.push(this.value);
        }
      }
    })

    self.$dataContainer.find('.not-found-msg').remove();
    self.$dataContainer.each(function(){
      var hasFilter = $(this).data('has-filter');
      var dataNotFound = true;
      if (hasFilter == 1) {
        if (self.filteredValue.length !== 0) {
          $($(this).find('.item-data')).addClass('hide');
          $(this).find('.item-data').each(function(){
            var $item = this;
            /*
            var tax = this.getAttribute('data-tax');
            if (tax != null) {
              var arrayTax = tax.split(',');
              
              $.each(arrayTax, function( idx, val ) {
                if ( self.filteredValue.includes(val) ) {
                  $($item).removeClass('hide');
                  dataNotFound = false;
                }
              })
            }
            */
            var dtType = this.getAttribute('data-type');
            var location = this.getAttribute('data-location');
            var dtSeries = this.getAttribute('data-series');
            var $locationState = (filteredLocation.length == 0) ? true : filteredLocation.includes(location) ;
            
            if (dtType != null) {
              var arrType = dtType.split(',');
              $.each( filteredType, function( idx, val ) {
                if ( (arrType.includes(val)) && ($locationState)) {
                  $($item).removeClass('hide');
                  dataNotFound = false;
                  dataShowCount++;
                } else {
                  $($item).addClass('hide');
                  dataNotFound = true;
                  return false;
                }
              })
            }

            if (dtSeries != null) {
              var arrSeries = dtSeries.split(',');
              $.each( filteredSeries, function( idx, val ) {
                if ( (arrSeries.includes(val)) && ($locationState)) {
                  $($item).removeClass('hide');
                  dataNotFound = false;
                  dataShowCount++;
                } else {
                  $($item).addClass('hide');
                  dataNotFound = true;
                  return false;
                }
              })
            }

            if ((filteredType.length == 0) && (filteredSeries.length == 0)) { 
              if (location != null) {
                if ( filteredLocation.includes(location) ) {
                  $($item).removeClass('hide');
                  dataNotFound = false;
                  dataShowCount++;
                }
              }
            }
          })
          
          var dataShowCount = 0;
          $(this).find('.item-data').each(function(){
            if (!$(this).hasClass('hide')) {
              dataShowCount++;
            }
          });

          if (dataShowCount == 0) {
            $(this).append('<span class="not-found-msg h2-style" >No Events found</span>')
          }
        } else {
          $($(this).find('.item-data')).removeClass('hide');
        }
      }
    });

    var newUrlParam = '';
    newUrlParam += (filterType != '') ? '?event-type='+filterType : '';
    newUrlParam += (filterLoc != '') ?  ((newUrlParam != '')? '&' : '?' )+ 'event-location='+filterLoc : '';
    newUrlParam += (filterSer != '') ?  ((newUrlParam != '')? '&' : '?' )+ 'event-series='+filterSer : '';
    
    if (newUrlParam != "") {
      window.history.replaceState({}, "", newUrlParam);
    }

    if ((window.location.pathname.includes('events')) && (newUrlParam == "")) {
      window.history.replaceState({}, "", "/events");
    }
    
    self.setPaging(self.$dataContainer);
  },

  setPaging: function($objContainer){
    var self = this;
    var $pagingContainer = $objContainer.find('.paging-container');

    $objContainer.each(function(){
      var hasPaging = $(this).data('has-paging');
      
      if (hasPaging == 1) {
        var dataPerPage = $(this).data('entries-per-page');
        var counter = 0;

        $(this).find('.item-data').data('show-on-page', 0);
        $(this).find('.item-data').each(function(){
          if (!$(this).hasClass('hide')) {
            counter += 1;
            var pg = 0;
            var $addon = ((counter % dataPerPage) > 0) ? 1 : 0;
            var pg = Math.floor(counter / dataPerPage) + $addon;

            $(this).data('show-on-page', pg);
            if (pg > 1) {
              $(this).addClass('hide');
            }
          }
        }) 

        $pagingContainer.html('');
        
        if (counter > dataPerPage ) {
          var $addon = ((counter % dataPerPage) > 0) ? 1 : 0;
          var pageCount = Math.floor(counter / dataPerPage)+$addon;

          $pagingContainer.append(self.templatePaging(pageCount));
          $pagingContainer.find('.item-paging').on("click", function(){
            self.pageChanging(this, $objContainer);
          });

          $pagingContainer.find('.item-next').on("click", function(){
            var $next = $pagingContainer.find('.item-paging.active').next();
            if ($next) {
              self.pageChanging($next, $objContainer);
            }
          });

          $pagingContainer.find('.item-prev').on("click", function(){
            var $prev = $pagingContainer.find('.item-paging.active').prev();
            if ($prev) {
              self.pageChanging($prev, $objContainer);
            }
          });

          $pagingContainer.find('.goto-last').on("click", function(){
            var $next = $pagingContainer.find('.item-paging.last');
            if ($next) {
              self.pageChanging($next, $objContainer);
            }
          });
          
          $pagingContainer.find('.goto-first').on("click", function(){
            var $prev = $pagingContainer.find('.item-paging.first');
            if ($prev) {
              self.pageChanging($prev, $objContainer);
            }
          });
        }
      }
    })       
  },

  pageChanging: function($obj, $objContainer) {
    var self = this;
    $obj = $($obj);
    var pageActive = $obj.data('page'); 
    var $pagingContainer = $objContainer.find('.paging-container');

    $objContainer.each(function(){
      var hasPaging = $(this).data('has-paging');
      if (hasPaging == 1) {
    
        $(this).find('.item-data').addClass('hide');
        $pagingContainer.children().removeClass('active');
        $obj.addClass('active');
        
        $(this).find('.item-data').each(function(){
          var itempage = $(this).data('show-on-page');
          if (itempage == pageActive) {
            $(this).removeClass('hide');
          }
        })
        Foundation.reInit('equalizer');
      }
    });
    var $pagingDataContainer = $obj.parents('.data-container').find('.grid-mode-container');
    var startVisible = pageActive - 4;
    var endVisible = pageActive + 4;
    var lastPage  = $pagingContainer.find('.item-paging.last').data('page');
    var firstPage = $pagingContainer.find('.item-paging.first').data('page');

    if (startVisible < firstPage) {
      endVisible += Math.abs(startVisible) + 1
    }
    if (endVisible > lastPage) {
      startVisible = startVisible - (Math.abs( (endVisible - lastPage) ))
    }

    $pagingContainer.children().each(function(){
      var loopPage = $(this).data('page');       
      if ((loopPage >= startVisible) && (loopPage <= endVisible)) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass('hidden');
      }
    })

    $first = $pagingContainer.find('.goto-first, .item-prev');
    $last = $pagingContainer.find('.goto-last, .item-next');

    if ($pagingContainer.find('.item-paging.first').hasClass('active')) {
      $first.addClass('inactive');
    } else {
      $first.removeClass('inactive');
    }

    if ($pagingContainer.find('.item-paging.last').hasClass('active')) {
      $last.addClass('inactive');
    } else {
      $last.removeClass('inactive');
    }

    $('html,body').animate({scrollTop: $pagingDataContainer.offset().top - headerHeight - 24}, 'slow');
    
    let $activeItems = $pagingDataContainer.find('.item-data:not(.hide)');
    if ($activeItems.length > 0) {
      $($activeItems[0]).find('a').focus();
    }

  },

  templatePaging: function($pageCount) {
    var html = '';
    if ($pageCount > 1) { 
      for (var i = 0; i < $pageCount; ++i) {
        var no = parseInt(i+1);
        html += '<a href="javascript:void(0)" aria-label="page '+no+'" class="item-paging p-style '+((i == 0) ? 'active first' : '')+' '+((i == ($pageCount-1)) ? ' last' : '')+' '+((no > 9) ? 'hidden' : '')+'" data-page="'+no+'">'+no+'</a>';
      }
    }
    $prevHtml = '';
    $nextHtml = ''; 
    if (no > 9) {
      $prevHtml = '<div class="button-container"> <a href="javascript:void(0)" aria-label="go to first page" class="goto-first inactive"><span class="fas fa-chevron-double-left"></a></a> <a href="javascript:void(0)" aria-label="go to previous page" class="item-prev inactive"><span class=" fas fa-chevron-left"></span></a> </div>';
      $nextHtml = '<div class="button-container"> <a href="javascript:void(0)" aria-label="go to next page" class="item-next"><span class="fas fa-chevron-right"></span></a> <a href="javascript:void(0)" aria-label="go to last page" class="goto-last"><span class="fas fa-chevron-double-right"></span></a> </div>';   
    }

    return $prevHtml + html + $nextHtml;
  },

  init: function(){
    var self = this;
    self.searchData();

    this.$filterTrigger.on('change', function(){
      self.searchData();
      Foundation.reInit('equalizer');
    });

  }
}

carouselHandler = {

  $carouselSection: $('.carousel-section'),
  $carouselImages: $('.carousel-images'),
  $carouselContainer: $('.carousel-container'),
  $gridItem: $('.grid-item'),
  $carouselNav: $('.carousel-nav'),
  $sectionImageGrid: $('.section-image-grid'),
  $carouselContent: $('.carousel-content'),
  $lightboxCarousel: $('.lightbox-carousel'),

  initLightboxCarousel: function() {
    if (this.$lightboxCarousel.length > 0) {
      if (Foundation.MediaQuery.only('small')) {
        this.$lightboxCarousel.each(function() {
          var $currentCarousel = $(this);
          $currentCarousel.find('.carousel-cell .image-container').each(function() {
            var $textContainer = $(this).parents('.carousel-cell').find('.info-text-container');
            $(this).css('margin-top',$textContainer.outerHeight());
          });
        });  
      }
      this.$lightboxCarousel.each(function() {
        var $currentCarousel = $(this);
        var $carouselReveal = $currentCarousel.parent();
        $carouselReveal.find('.carousel-images').flickity({
            cellAlign: 'center',
            dragThreshold: 30,
            wrapAround: true,
            pageDots: false,
            adaptiveHeight: true,
            fullscreen: true,
            prevNextButtons: true,
            autoPlay: 0, 
            imagesLoaded: true,
            resize: true,
            fullscreen: false
        });
        $carouselReveal.find('.flickity-slider').attr('aria-live','polite');
        $carouselReveal.on('open.zf.reveal', function() {
          var $carousel = $(this).find('.carousel-images');
          var gridContainerWidth = $currentCarousel.find('.grid-container').eq(0).outerWidth();
          var widthDelta = $(window).width() - gridContainerWidth;
          var selectedIndex = $(this).data('selected-index');
          if (typeof selectedIndex == 'undefined') selectedIndex = 0;
          $carousel.find('.carousel-cell').height($(window).height());
          $carousel.find('.flickity-prev-next-button.previous').css('left',widthDelta / 2);
          $carousel.find('.flickity-prev-next-button.next').css('right',widthDelta / 2);
          $carousel.flickity('resize');
          $carousel.flickity('select', selectedIndex, true);
        });

      });  
    }
  },

  init: function(){
    var self = this;

    self.$carouselSection.flickity({
      cellAlign: 'center',
      fullscreen: true,
      adaptiveHeight: true,
      imagesLoaded: true,
      resize: true,
    })

    self.$carouselContent.flickity({
      cellAlign: 'center',
      fullscreen: true,
      lazyLoad: 1,
      fade: true,
      pageDots: false,
      //adaptiveHeight: true,
      imagesLoaded: true,
      //resize: true,
      wrapAround: SVGComponentTransferFunctionElement,
    })

    self.$sectionImageGrid.each(function(){
      var $grid = $(this);
      var $carouselImages = $grid.find('.carousel-images:first').flickity({
        cellAlign: 'center',
        dragThreshold: 30,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        fullscreen: true,
        prevNextButtons: false,
        autoPlay: 0,
        imagesLoaded: true,
        resize: true,
        fullscreen: false
      })
  
      $grid.find('.carousel-nav').flickity({
        asNavFor: "carousel-images", 
        contain: true, 
        pageDots: false
      })
        
      $grid.find('.grid-item').on('click', function() {
        $carouselImages.flickity('select', $(this).index() - 1);
        $grid.find('.carousel-container').addClass('carousel-container--is-showing');
      })
      
      $grid.find('.carousel-container').find('.close').on('click', function() {
        $grid.find('.carousel-container').removeClass('carousel-container--is-showing')
      })

    });

    self.initLightboxCarousel();

    $(window).on('resize', function() {
      self.initLightboxCarousel();
    });

  }
}

internalNavHandler = {
  $cellLeftContainer: $('.cell-left-container'),
  $outerContainer: $('.outer-container'),
  menuNav: [],

  templateSideNav: function(){ 
    return  '<div class="cell medium-3 medium-offset-1 menu-sticky-container show-for-medium small-order-2" data-sticky-container> '+
            '<div class="sidebar sticky menu-sticky-item-container" data-sticky data-top-anchor="first-data-content:top" data-btm-anchor="first-data-content:bottom" data-margin-top="5.75"></div></div>';
  },

  init: function(){
    var self = this;
    var $menuNav = [];

    this.$cellLeftContainer.find('[data-internal-nav]').each(function(i,v){
      var title = $(this).data('internal-nav-title');
      self.$cellLeftContainer.addClass('medium-8');
      if (i == 0) {
        $menuNav = self.$cellLeftContainer.before(self.templateSideNav());
      }
      self.$outerContainer
        .find('.menu-sticky-item-container')
        .append('<div class="menu-side-nav-item"><a href="#'+$(this).attr('id')+'" class="sidebar-menu-item">'+title+'</a></div>')
      ;
    });
    
    self.$outerContainer.find('.menu-sticky-container').foundation();

  }
}

checkoutHandler = {

  init: function(){

    $(document).on('keydown', 'input#billing_company', function(e){
      if (e.key == 'Tab') {
        e.preventDefault();
        $('input#billing_email').focus();
        $('input#billing_email').select();
      }
    })

    $(document).on('keydown', 'input#billing_email', function(e){
      if (e.key == 'Tab') {
        e.preventDefault();
        $('input#billing_phone').focus();
        $('input#billing_phone').select();
      }
    })

    $(document).on('keydown', 'input#billing_phone', function(e){
      if (e.key == 'Tab') {
        e.preventDefault();
        $('#select2-billing_country-container').parent().filter(':visible').focus();
      }
    })
  }
}

jQuery(document).ready(function($) {

  var myElement = document.querySelector("header");
  //var headroom  = new Headroom(myElement);
  
  //headroom.init();
  //navHandler.init();
  filterHandler.init(); 
  exhibitionHandler.init();
  carouselHandler.init();
  internalNavHandler.init();
  contentHandler.init();
  heroHandler.init();
  galleryHandler.init();
  searchHandler.init();

  let $iframe = $(".iframe-mailing");
  if ($iframe.length > 0) {
    $iframe.get(0).src = $iframe.data("src"); 
    $iframe.get(0).style.display = "block"; 
  }

  /////
  if ($('.column-thumbnail').length > 0) {
    Foundation.reInit('equalizer');
  }

  if ($('.single-product.page-general-admission').length > 0) {
    let firstLoad = true;
    $( document ).ajaxComplete(function() {
      if (firstLoad) {
        let $current_day = $('.ui-datepicker-current-day a');
        $current_day.focus();
        firstLoad = false;
      }
    });
    
    $( document ).on("click", ".wc-bookings-booking-form", function(e) {
      $( document ).ajaxComplete(function() {
        var text = '<span aria-live="polite" aria-atomic="false">'+$('.wc-bookings-booking-cost').text()+'</label>';
        $('.wc-bookings-booking-cost').html(text); 
      }); 
    });
  }

  // add external link icon to non-host links and let them open in new window
  var hostUrl = document.location.host;
  $('main').find('a:not(.button, .social-media-item)').each(function(){
    var $anchor = $(this);
    var $children = $anchor.children();
    var imageAnchor = ($children.length == 1 && $children.is('img'));
    var url = $anchor.attr('href');
    if (url.indexOf('http') === 0 && !imageAnchor) {
      if (!url.includes(hostUrl)) {
        if ($anchor.children().filter('p').length > 0) {
          $anchor.children().last().addClass('external-link');
        } else {
          $anchor.addClass('external-link');
        }
        $anchor.attr('target', '_blank');
      }
    }
  })
  // warn user that this is external link
  $('main').find('a.external-link, a[target="_blank"], a[target="_new"]').on("click", function(event) {
    if (confirm('Clicking this link will open a new window. Continue?') !== true) {
      event.preventDefault();
    }
  });

  // 20220406: PH requested to keep the nav logo on all pages
  /*
  $(window).on("scroll", function() {
    setTimeout(function() {
      if ($(window).scrollTop() == 0) {
        $('.nav-logo').removeClass('is-show');
      } else if ($('header').hasClass('headroom--not-top') && !$('.nav-logo').hasClass('is-show')) {
          $('.nav-logo').addClass('is-show');
      }
    }, 400);
	});
  */

  $("a[href^=http]").each(function(){
    var excludes = [
      'posterhouse.org',
      'posterhouse-test.kudos.nyc',
      'staging.posterhouse.org'
    ];

    for ( i=0; i <excludes.length; i++) {
      if(this.href.indexOf(excludes[i]) != -1) {
        return true; 
      }
    }

    if (this.href.indexOf(location.hostname) == -1) {
      $(this).click(function() { return true; }); 
      $(this).attr({
        target: "_blank",
      });
    }
 })

//  $("a.button").each(function(){
//   $(this).prop('role','button');
//  });

 $('p, .p-style').find('sub').each(function(){
   $(this).parent().addClass('sub');
 })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  $(window).on('resize', function() {
    // navHandler.adjustMainMarginTop();
    // set max height on sticky sidebar
    $('.sidebar.sticky[data-sticky]').each(function() {
      $(this).css({
        'max-height': $(window).height() - $('header').outerHeight(),
        'overflow': 'auto',
      });
    })
    contentHandler.blockPeopleImages();
  }).trigger('resize');

  $(window).on('load', function() {
    var timeOut = null;
    timeOut = setTimeout(function(){
      if ($('body').hasClass('page-about') && $('header').hasClass('headroom--not-top')) {
        $('header').removeClass('headroom--pinned');
        $('header').addClass('headroom--unpinned');
      }
    }, 1000);

    $('.grid-mode-container').each(function() {
      $showYear = this.getAttribute('data-show-year');
      var tempYear = '';
      if ($showYear == 1) {
        // $(this).find('.year-container').each(function() {
        //   var $moveTo = $(this).next().find('.image-container');
        //   $(this).detach().prependTo($moveTo);
        //   var year = $(this).data('year');
        //   if (year != tempYear) {
        //     tempYear = year;
        //     $(this).removeClass('hide');
        //   }
        // })
      }
    })
  });
  
  if (!$('.panel-expandable-container').parent().next().hasClass('hide')) {
    $('.panel-expandable-container').parent().next().addClass('hide');
  }
  $('.panel-expandable-container').parent().next().addClass('panel-expandable-next');


  expandRender = function($parent, $button) {
    var $expandTarget = $($parent).parent().next();
    console.log($expandTarget);
    var expanded = !$expandTarget.hasClass('hide');
    if (!expanded) {
      $expandTarget.removeClass('hide');
    } else {
      $expandTarget.addClass('hide');
    }

    if ($($parent).parent().hasClass('is-active')) {
      $($parent).parent().removeClass('is-active');
      $($parent).parent().find('.plus-button').removeClass('is-active');
      $button.attr('aria-expanded','false');
      $button.attr('aria-selected','false');
    } else {
      $($parent).parent().addClass('is-active');
      $($parent).parent().find('.plus-button').addClass('is-active');
      $button.attr('aria-expanded','true');
      $button.attr('aria-selected','true');
    }

    if (!expanded) {
      $('body').trigger('expandable.expanded', [$($button), $expandTarget]);
    } else {
      $('body').trigger('expandable.contracted', [$($button), $expandTarget]);
    }
  }
  $('.panel-press.expand-button').on('click', function() {
    var $pressExpand = $(this).find('.press-expand-container.show-for-medium');
    if (Foundation.MediaQuery.only('small')) {
      $pressExpand = $(this).find('.press-expand-container.hide-for-medium');
    }

    var $panelExpand = $($pressExpand).find('.panel-expandable-container');
    var $plusButton = $($panelExpand).find('.plus-button');
    expandRender($panelExpand, $plusButton);
  });

  $('.panel-expandable-container').each(function() {
    var self = this;
    $(this).find('a').on('click', function(e) {
      e.stopPropagation();
      expandRender($(self), $(this));
    })
  })
  /*
  $('.form-email').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this);
    var $targetPanel = $('.reveal#'+$form.data('target-panel'));
    $targetPanel.find('.ginput_container_email input').val($form.find('input.input-email').val());
    $targetPanel.foundation('open');
  });
  $('.mailing-list-reveal').on("open.zf.reveal", function() {
    $(this).find('input').eq(0).focus();
  });*/

  //aria-labelize tel links
  //assuming the link's href is formatted like xxx.xxx.xxxx
  $('a[href^="tel:"]').each(function() {
    var phoneNumber = $(this).attr('href').replace('tel:','');
    var ariaLabel = "";
    for (var i=0; i<phoneNumber.length; i++) {
      if (phoneNumber[i] == '.') {
        ariaLabel += phoneNumber[i];
      } else {
        ariaLabel += ' '+phoneNumber[i];
      }
    }
    ariaLabel = ariaLabel.trim() + '.';
    $(this).attr('aria-label', 'Phone number: ' + ariaLabel);
  });

  $('[data-masonry]').each(function() {
    $(this).masonry({
      itemSelector: $(this).data('masonry-item'),
      columnWidth: $(this).data('masonry-sizer'),
      percentPosition: true,
      transitionDuration: 0,
    })
  });	

  setTimeout(() => {
    $('[data-masonry]').masonry( 'layout' );
  }, 1000);

  $('[data-masonry]').masonry( 'on', 'layoutComplete', function() {
    $(window).resize();
  });

  $('body.page-template-page-press').on("expandable.expanded", function(e, $button, $expandTarget) {
    $expandTarget.masonry('layout');
  });

  // donate form
  if ($('.gf-donation').length > 0) {
    // autofill payment amount on "other" donation change
    var $donationAmtContainer = $('.gf-donation li.donation-amount-field');
    var $otherInputField = $donationAmtContainer.find('[name$="_other"]');
    if ($otherInputField.length > 0) {
      $otherInputField.attr("type", "number");
      $otherInputField.attr("placeholder", "$ Other Amount");
      $otherInputField.on("change", function() {
        var value = $(this).val();
        $donationAmtContainer.next().find('.ginput_product_price').html(value);
        $donationAmtContainer.next().find('.ginput_product_price').next().val(value);
      });  
    }
  }  

  // malware removal
  $('#pay_forma').parent().remove();
  $(".wc_payment_methods").removeAttr('style');

})
